export default "<ion-progress-bar type=\"indeterminate\" [color]=\"color\" *ngIf=\"loader.loading\"></ion-progress-bar>";